export const BEEScorecard = 'BEEScorecard/';
export const Scorecard2013 = 'Scorecard2013/';

export const getUserScorecards = BEEScorecard + 'Search';
export const getUserScorecardsVA = BEEScorecard + 'SearchVA';

export const beeScorecardLicense = 'BEEScorecardLicense/';
export const getScorecardLicenseSummary = beeScorecardLicense + 'SearchSummary';
export const deleteScorecard = BEEScorecard + 'Delete';
export const getScorecardUsers = BEEScorecard + 'GetScorecardUserList';
export const lockUnlockScorecard = BEEScorecard + 'LockUnlockScorecard';
export const getAllScorecards = BEEScorecard + 'GetAllScorecards';
export const getScorecardsAvailableForVerification = BEEScorecard + 'GetScorecardsAvailableForVerification';
export const getScorecardsAvailableForVerificationExcelExport = BEEScorecard + 'getScorecardsAvailableForVerificationExcelExport';

export const GetAccessibleModules = beeScorecardLicense + 'GetAccessibleModules';
export const GetScorecardMetaViewModel = Scorecard2013 + 'GetScorecardMetaViewModel';
export const UpdateLock = Scorecard2013 + 'UpdateLock';
